import Link from "next/link";
import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { GrChatOption } from "react-icons/gr";

const TwoButtonsLarge = () => {
  return (
    <div className="flex flex-col gap-4">
      <Link href="/appointment">
        <BookAppointment />
      </Link>
      <Link href="https://wa.me/+919000566767">
        <WhatsApp />
      </Link>
    </div>
  );
};

export default TwoButtonsLarge;

const BookAppointment = () => {
  return (
    <div className="rounded-lg bg-rose-500 px-5 py-10 transition duration-500 ease-in-out hover:bg-blue-800">
      <GrChatOption size={60} />

      <p className="pt-5 text-center text-white">Schedule an consultation</p>
    </div>
  );
};

const WhatsApp = () => {
  return (
    <div className="rounded-lg bg-green-600 px-5 py-10 transition duration-500 ease-in-out hover:bg-blue-800">
      <FaWhatsapp size={60} />
      <p className="pt-5 text-center text-white">
        WhatsApp quick connect with us
      </p>
    </div>
  );
};
